import React, { Fragment} from 'react';

const PaginationsUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row">
        <div className="left">
          <h1 className="page-title">
            Pagination is used for splitting up content or data into several pages.
          </h1>
        </div>
        <div className="right copy-content">
          <p>Pagination elements are used when there is the need to split up data or content into several pages, with a control for navigation to the next or previous page. Generally, pagination is used if there are more than 10 items displayed in one view. The default number displayed will vary depending on the context. There are several types of pagination elements:</p>
        </div>
      </article>
    </section>

    <section className="bg-grey with-padding flex-grow-1">
      <article className="flex-justify-end flex-row last">
        <div className="right copy-content">
          <h2 className="page-subtitle">Numeral</h2>
          <p>Between the minimum count of 2 pages and the maximum of 10, all pages are visible and can be navigated using the directional arrows or keyboard, above 10 pages the pagination truncates by showing ellipsis between the current pages selected and the last one.</p>

          <h2 className="page-subtitle">Horizontal Carousel</h2>
          <p>The carousel element has a minimum of 2 and a maximum of 10 pages and can be static or work with a timer. When static the content will only change when selecting a new page. If it’s using a timer, the page will change after a pre-determined time.</p>

          <h2 className="page-subtitle">Vertical Carousel</h2>
          <p>Similarly to the horizontal static carousel, but it also includes a page name label. The page name label changes with the selection of a new page from the carousel.</p>

          <h2 className="page-subtitle">Views per Page</h2>
          <p>This dropdown shows the tables per page and it is preferably used on the top of the page, but when that is not possible it should be inserted at the bottom of the page, next to the pagination UI. A click or tap on the element triggers the native dropdown of the browser.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default PaginationsUsage;



// WEBPACK FOOTER //
// ./src/containers/elements/Paginations/PaginationsUsage.js